<template>
  <div>
    <div class="content-checkbox">
      <input
        v-model="checked"
        type="checkbox"
        :value="component.name"
        class="cb"
      />
      <label class="text-value">{{ component.label }}</label>
    </div>
    <div class="content-group">
      <template v-if="checked"
        ><RenderPreview
          v-for="field in stepFieldPreview"
          :key="field.name"
          :component="field"
        ></RenderPreview
      ></template>
    </div>
    <template v-if="!checked"
      ><RenderPreview
        v-for="field in component?.fields1"
        :key="field.name"
        :component="field"
      ></RenderPreview
    ></template>
  </div>
</template>
<script>
export default {
  name: 'GroupCheckbox',

  components: {
    RenderPreview: () => import('./RenderPreview.vue'),
  },

  props: {
    component: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    checked: false,
  }),

  computed: {
    stepFieldPreview() {
      const nomesParaRemover = this.component?.fields1
        ? this.component?.fields1.map(campo => campo.name)
        : ''

      return this.component.fields.filter(campo => {
        return !nomesParaRemover.includes(campo.name)
      })
    },
  },
}
</script>
<style scoped>
.content-checkbox {
  display: flex;
  padding: 10px 5px;
  background-color: #f8f8f8;
}
.content-group {
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.text-value {
  /* font-weight: bold; */
  font-size: 14px;
  font-family: 'Rajdhani', sans-serif;
  color: #69739e;
  padding-left: 10px;
}

.cb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  cursor: pointer;
  background-color: white;
  border: 2px solid #10dd2c;
  position: relative;
  display: inline-block;
}

.cb::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.2s ease-in-out;
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  background-color: #10dd2c;
}

.cb:checked {
  background-color: white;
  border-color: #10dd2c;
}

.cb:checked::before {
  transform: translate(-50%, -50%) scale(1); /* Exibe o 'V' */
}
</style>
